import { useTheme } from '../hooks/useTheme'

// styles
import './Footer.css'

export default function Footer() {
    const { color } = useTheme()

    return (
        <div className='footer'>
            <h3 style={{ color: color }}>Copyright 2025 Claire Filipek | CS Education Portfolio</h3>
        </div>
    )
}